export default {"src":"/_next/static/media/support.681942e7.svg","height":30,"width":30};